<template>
  <div class="text-danger text-xs leading-6">
    <ErrorMessage v-if="name" as="span" :name="name" />
    <span v-else-if="message">
      {{ message }}
    </span>
  </div>
</template>

<script>
import { ErrorMessage } from 'vee-validate';

export default {
  components: {
    ErrorMessage,
  },
  props: {
    name: {
      type: String,
    },
    message: {
      type: String,
    },
  },
  setup() {},
};
</script>

<style lang="scss" scoped></style>
